import { type BetslipView } from '@nsftx/seven-client-sdk-integrator'
import apiInstance from './bettingAcceptanceApiClient'

const getBetslipById = (id: string) =>
  apiInstance<BetslipView>({
    method: 'GET',
    url: `/betslips/${id}`
  })

const payoutTicket = (id: string, betIds: string[]) =>
  apiInstance({
    method: 'POST',
    url: `/betslips/${id}/actions/payout-bets`,
    data: {
      payoutBetIds: betIds
    }
  })

export { getBetslipById, payoutTicket }
